import { useState } from 'react'
import styles from './FAQSection.module.scss'

const faqs = [
    {
        id: 1,
        question: 'Какое расписание?',
        answer: 'Мы работаем каждый день с 10:00-20:00 - без выходных. Занятия проходят как в будни, так и в выходные. Все зависит от возраста и уровня знаний. Занятия могут проходить: очно по нашим адресам так и индивидуально. А также есть индивидуальный онлайн-формат.',
    },
    {
        id: 2,
        question: 'Кто преподаватели?',
        answer: 'Все преподаватели обладают высшим техническим или педагогическим образованием. Которые регулярно проходят повышения квалификации. Основная цель наших преподавателей - объяснить сложные вещи простыми словами, также стать другом и поддержкой для каждого.',
    },
    {
        id: 3,
        question: 'Сколько длится занятие?',
        answer: 'Занятия по IT-направлениям от 60 до 90 минут, по Развитию интеллекта от 75 минут до 105 минут. Также зависит от возраста.',
    },
    {
        id: 4,
        question: 'Сколько детей в группе?',
        answer: 'В группах от 8-10 человек.',
    },
    {
        id: 5,
        question: 'Что приносить с собой?',
        answer: 'Каждому мы предоставляем все необходимое индивидуальное оборудование. С собой только вторую обувь и хорошее настроение.',
    },
    {
        id: 6,
        question: 'Выдается ли сертификат об обучении?',
        answer: 'Да, у нас более 30-ти ступеней обучения, которые подбирается под возраст ребенка и после окончания каждой ступени и прохождения итогового тестирования, мы выдаем сертификаты государственного образца.',
    },
]

export default function FAQSection() {
    const [openId, setOpenId] = useState(1)

    const toggle = (id) => {
        setOpenId(openId === id ? null : id)
    }

    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    {/* Левая колонка */}
                    <div className={styles.leftCol}>
                        <div className={styles.stickyContent}>
                            <h2 className={styles.title}>
                                Отвечаем на <br /> частые вопросы
                            </h2>

                            <div className={styles.imageWrapper}>
                                <img
                                    src="/img/stock/faq.png"
                                    alt="FAQ иллюстрация"
                                    className={styles.image}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Правая колонка - Аккордеоны */}
                    <div className={styles.rightCol}>
                        <div className={styles.accordion}>
                            {faqs.map((item) => {
                                const isOpen = openId === item.id

                                return (
                                    <div
                                        key={item.id}
                                        className={`${styles.item} ${isOpen ? styles.open : ''}`}
                                        onClick={() => toggle(item.id)}
                                    >
                                        <div className={styles.itemHeader}>
                                            <h3 className={styles.question}>{item.question}</h3>
                                            <button className={styles.toggleBtn}>
                                                {isOpen ? '×' : '+'}
                                            </button>
                                        </div>

                                        <div
                                            className={styles.itemBody}
                                            style={{ maxHeight: isOpen ? '500px' : '0' }}
                                        >
                                            <div className={styles.answerWrapper}>
                                                <p className={styles.answer}>{item.answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
